export default __webpack_public_path__ + "static/media/G0750.34I-27929_-17384_0.1666264620000.2294a62e.jpg";